import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-editor-block',{attrs:{"identifier":_vm.identifier,"type":"banner","contentAttr":"image"},scopedSlots:_vm._u([{key:"default",fn:function({ content }){return [(content)?_c(VImg,_vm._b({attrs:{"src":content,"alt":"..."}},'v-img',_vm.$attrs,false)):_c(VSkeletonLoader,{attrs:{"type":"image"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }